<template>
  <b-form-group
    label="8. SK Penggunaan"
    label-for="skPenggunaan"
  >
    <b-form-radio
      v-model="skPenggunaan"
      value="1"
      disabled
    >
      Ada SK Penggunaan
    </b-form-radio>
    <b-col
      v-if="skPenggunaan === '1'"
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-group
        label="Nomor SK Penggunaan"
        label-for="nomorSkPenggunaan"
      >
        <slot name="nomorSkPenggunaan" />
      </b-form-group>
      <b-form-group
        label="Tahun SK Penggunaan"
        label-for="tahunSkPenggunaan"
      >
        <slot name="tahunSkPenggunaan" />
      </b-form-group>
    </b-col>
    <b-form-radio
      v-model="skPenggunaan"
      disabled
      value="0"
    >
      Tidak Ada SK Penggunaan
    </b-form-radio>
  </b-form-group>
</template>
<script>
export default {
  props: {
    skPenggunaan: { type: String, default: null },
  },
}
</script>
